import React, { useContext } from "react";
import { observer } from "mobx-react";
import { StoresContext } from "../../../pages/_app";
import { KMER_LEN } from "../../../utils/search";

export const NoResults = observer(() => {
  const rootStore = useContext(StoresContext);
  const { mineOnly, sequenceSearchEnabled, sequenceSearchValue } = rootStore.genomeStore;
  const sequenceSearchTooShort = sequenceSearchEnabled && sequenceSearchValue.length < KMER_LEN;

  let text: string;
  if (sequenceSearchTooShort) {
    text = `Please enter at least ${KMER_LEN} bases to search for microbes containing the sequence`;
  } else if (mineOnly) {
    text = "No Starred Microbes";
  } else {
    text = "No Available Microbes";
  }
  return (
    <div>
      <h3>{text}</h3>
    </div>
  );
});
